import { UPDATE_DEFAULT_AIRPORT, UPDATE_DEFAULT_TENANT } from './types';

const BACKEND_API = 'BACKEND_API';

export const updateDefaultAirport = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: `portal/${id}/default_airport/`,
    data,
    ...UPDATE_DEFAULT_AIRPORT
  }
});

export const updateDefaultTenant = id => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: `portal/${id}/default_tenant/`,
    ...UPDATE_DEFAULT_TENANT
  }
});
